"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidSelectValue = isValidSelectValue;
exports.getNextSelectAtom = getNextSelectAtom;
exports.getSelectAtomSubRuleId = getSelectAtomSubRuleId;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _utils = require("../utils");

var Option = _antd.Select.Option;

var RuleEditorSelect = function RuleEditorSelect(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(_antd.Select, {
    dropdownMatchSelectWidth: false,
    key: atom.options.find(function (o) {
      return o.value === value;
    }).label,
    value: value || atom.default,
    onChange: function onChange(value) {
      setValue(value);
    },
    options: atom.options.filter(function (opt) {
      return !opt.hidden || opt.value === value;
    }).map(function (opt) {
      return {
        label: opt.label,
        value: opt.value
      };
    })
  });
};

var _default = RuleEditorSelect;
exports.default = _default;

function isValidSelectValue(atom) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  var hasValue = atom.options.some(function (o) {
    return o.value === value;
  });
  return atom.type === "select" && hasValue;
}

function getNextSelectAtom(atom, _ref3) {
  var value = _ref3.value;
  var optionId = value;
  var option = atom.options.find(function (o) {
    return o.value === optionId;
  });
  return option.next || atom.next;
}

function getSelectAtomSubRuleId(_ref4) {
  var idx = _ref4.idx,
      atom = _ref4.atom,
      values = _ref4.values,
      processors = _ref4.processors;
  var v = (0, _utils.getValue)(idx, atom, values) || (0, _utils.getDefaultValue)(idx, atom, values, processors);
  var value = v.value;
  var optionId = value;
  var option = atom.options.find(function (o) {
    return o.value === optionId;
  });
  var subRuleId = option.subRule || atom.subRule;
  var requiredSubRule = Boolean(option.requiredSubRule || atom.requiredSubRule);
  var singleSubRule = Boolean(option.singleSubRule || atom.singleSubRule);
  var subRuleType = option.subRuleType || atom.subRuleType;
  return subRuleId ? {
    subRuleId: subRuleId,
    requiredSubRule: requiredSubRule,
    singleSubRule: singleSubRule,
    subRuleType: subRuleType
  } : {};
}